export default {
  data() {
    return {
      rules: {
        required: (v) => !!v || v === 0 || v === '0' || v === false || this.$t('rule.required'),
        defined: (v) => v !== undefined || this.$t('rule.required'),
        checked: (v) => (v !== false && !(Array.isArray(v) && v.length === 0)) || this.$t('rule.required'),
        min: (number) => (v) => !v || v >= number || this.$t('rule.min', [number]),
        max: (number) => (v) => !v || v <= number || this.$t('rule.max', [number]),
        minlength: (length) => (v) => !v || v.length >= length || this.$t('rule.minlength', [length]),
        maxlength: (length) => (v) => !v || v.length <= length || this.$t('rule.maxlength', [length]),
        mincheck: (length) => (v) => !v || v.length >= length || this.$t('rule.mincheck', [length]),
        maxcheck: (length) => (v) => !v || v.length <= length || this.$t('rule.maxcheck', [length]),
        mindate: (date) => (v) => !v || v >= date || this.$t('rule.mindate', [date]),
        maxdate: (date) => (v) => !v || v <= date || this.$t('rule.maxdate', [date]),
        lines: (length) => (v) => !v || v.split('\n').length <= length || this.$t('rule.lines', [length]),
        filesize: (size, unit = 'MB') => {
          let realSize = size
          if (unit == 'KB') {
            realSize = Math.floor(size * 1024)
          } else if (unit == 'MB') {
            realSize = Math.floor(size * 1048576)
          }
          return (v) =>
            !v ||
            (Array.isArray(v) && v.reduce((acc, cur) => acc + cur.size, 0) < realSize) ||
            (!Array.isArray(v) && v.size < realSize) ||
            this.$t('rule.filesize', [size, unit])
        },
        filetype: (filetypes) => {
          return (v) =>
            !v ||
            (Array.isArray(v) && v.every((item) => filetypes.includes(item.type))) ||
            (!Array.isArray(v) && filetypes.includes(v.type)) ||
            this.$t('rule.filetype')
        },
        int: (v) => !v || /^(0|-?[1-9][0-9]*)$/.test(v) || this.$t('rule.int'),
        numeric: (v) => /^[0-9]*$/.test(v) || this.$t('rule.numeric'),
        alphanumeric: (v) => /^[0-9a-zA-Z]*$/.test(v) || this.$t('rule.alphanumeric'),
        decimal: (v) => !v || /^(0|-?[1-9][0-9]*)(\.[0-9]+)?$/.test(v) || this.$t('rule.decimal'),
        zipcode: (v) => /^([0-9]{3}-?[0-9]{4})?$/.test(v) || this.$t('rule.zipcode'),
        tel: (v) => /^(\+?[0-9]{0,4}(-?[0-9]{1,4}){0,5})?$/.test(v) || this.$t('rule.tel'),
        email: (v) =>
          /^((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))?$/.test(
            v,
          ) || this.$t('rule.email'),
        emails: (v) =>
          /^((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))(,(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))*)?$/.test(
            v,
          ) || this.$t('rule.emails'),
        url: (v) => !v || /^https?:\/\/[\w/:%#$&?()~.=+-]*$/.test(v) || this.$t('rule.url'),
        localurl: (v) => !v || /^(https?:\/)?\/[\w/:%#$&?()~.=+-]*$/.test(v) || this.$t('rule.localurl'),
        color: (v) => !v || /^(#[0-9a-fA-F]{6}|#[0-9a-fA-F]{8})?$/u.test(v) || this.$t('rule.color'),
        furigana: (v) => !v || /^[ぁ-んァ-ヶーｦ-ﾟ・＝=\u{20}\u{3000}]*$/u.test(v) || this.$t('rule.furigana'),
        account_kana: (v) =>
          !v ||
          /^[0-9A-Zｱ-ﾟ().\-/ぁ-わをんァ-ワヲ-ヶー゛゜（）．／\u{20}\u{3000}]*$/u.test(v) ||
          this.$t('rule.account_kana'),
        password: (v) => /^[0-9a-zA-Z!-/:-@[-``{-~]*$/.test(v) || this.$t('rule.password'),
        complexpassword: (v) =>
          v === null ||
          v === '' ||
          (!/^[0-9]*$/.test(v) && !/^[a-z]*$/.test(v) && !/^[A-Z]*$/.test(v) && !/^[!-/:-@[-``{-~]*$/.test(v)) ||
          this.$t('rule.complexpassword'),

        date: (v) => {
          if (!v) return true
          if (!v.match(/^([0-9]+)-([0-9]+)-([0-9]+)$/)) {
            return this.$t('rule.date')
          }
          const [y, m, d] = v.split('-')
          if (y.length !== 4) {
            return this.$t('rule.date')
          }
          const inputDate = new Date(y, m - 1, d)
          if (m != inputDate.getMonth() + 1) {
            return this.$t('rule.date')
          }
          return true
        },

        datetime: (v) => {
          if (!v) return true
          if (!v.match(/^([0-9]+)[-/]([0-9]+)[-/]([0-9]+)[ T]([01][0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/)) {
            return this.$t('rule.datetime')
          }
          const [y, m, d] = v.replace(/[ T].*$/, '').split(v.indexOf('-') >= 0 ? '-' : '/')
          if (y.length !== 4) {
            return this.$t('rule.datetime')
          }
          const inputDate = new Date(y, m - 1, d)
          if (m != inputDate.getMonth() + 1) {
            return this.$t('rule.datetime')
          }
          return true
        },

        time: (v) => !v || /^([01][0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/.test(v) || this.$t('rule.time'),

        javascript: (v) => {
          if (!v) return true
          try {
            new Function(`return ${v}`)
            return true
          } catch (e) {
            return this.$t('rule.javascript')
          }
        },

        required_per_line: (v) => {
          if (
            v.split('\n').some((line) => {
              return line.replace('\r', '').length == 0
            })
          ) {
            return this.$t('rule.required_per_line')
          }
          return true
        },
        minlength_per_line: (length) => {
          return (v) => {
            if (
              v.split('\n').some((line) => {
                return line.length < length
              })
            ) {
              return this.$t('minlength_per_line', [length])
            }
            return true
          }
        },
        maxlength_per_line: (length) => {
          return (v) => {
            if (
              v.split('\n').some((line) => {
                return line.length > length
              })
            ) {
              return this.$t('maxlength_per_line', [length])
            }
            return true
          }
        },
        users_per_line: (v) => {
          let message = this.$t('rule.users_per_line')
          let emails = {}
          if (
            v.split('\n').some((line) => {
              line = line.replace('\r', '').split(',', 2)
              if (line.length < 2) {
                message = this.$t('rule.users_per_line_format')
                return true
              } else if (line[0].length > 128) {
                message = this.$t('rule.users_per_line_email_minlength')
                return true
              } else if (line[1].length > 64) {
                message = this.$t('rule.users_per_line_name_minlength')
                return true
              } else if (line[1] === '') {
                message = this.$t('rule.users_per_line_name_required')
                return true
              } else if (line[0] in emails) {
                message = this.$t('rule.users_per_line_email_duplicated')
                return true
              }
              emails[line[0]] = true
              return !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                line[0],
              )
            })
          ) {
            return message
          }
          return true
        },
        passwords_per_line: (v) => {
          if (
            v.split('\n').some((line) => {
              return !/^[0-9a-zA-Z9!-/:-@[-`{-~]+$/.test(line.replace('\r', ''))
            })
          ) {
            return this.$t('rule.passwords_per_line')
          }
          return true
        },
      },
    }
  },
}
